// extracted by mini-css-extract-plugin
export default {"container":"SlideTitle_container__bC6GP","content":"SlideTitle_content__y4eQd","container2":"SlideTitle_container2__n6ndh","container3":"SlideTitle_container3__mvGpx"};